export default __webpack_public_path__ + "static/media/solution_center.3d914412.svg";